import { render, staticRenderFns } from "./DashboardTrendbox.vue?vue&type=template&id=1a3e1d74&scoped=true"
import script from "./DashboardTrendbox.vue?vue&type=script&lang=js"
export * from "./DashboardTrendbox.vue?vue&type=script&lang=js"
import style0 from "./DashboardTrendbox.vue?vue&type=style&index=0&id=1a3e1d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e1d74",
  null
  
)

export default component.exports